import {AfterContentInit, ChangeDetectionStrategy, Component, Input, OnDestroy, ViewChild} from '@angular/core';
import {
  ApDynformsComponent
}                                                                                          from '../../ap-dynforms/ap-dynforms.component';
import {
  ApDynformsConfigFieldset
}                                                                                          from '../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {
  ApDynformsValidator
}                                                                                          from '../../ap-dynforms/ap-dynforms-validator';
import {FormGroup, ValidatorFn, Validators}                                                from '@angular/forms';
import {
  ApDynformsConfigTextbox, ApDynformsConfigTextboxType
} from '../../ap-dynforms/config/ap-dynforms-config-textbox';
import {merge}                                                                             from 'lodash';
import {BehaviorSubject, Subscription}                                                     from 'rxjs';
import {
  UserStore
}                                                                                          from '../../stores/base-data/user.store';
import {
  InvitationStore
}                                                                                          from '../../stores/login/invitation.store';
import {
  TranslationStore
}                                                                                          from '../../stores/translation/translation.store';
import {
  RouterStore
}                                                                                          from '../../stores/router/router.store';
import {filter, map}                                                                       from 'rxjs/operators';
import {StringFactory}                                                                     from 'ts-tooling';
import {
  ApDynformsPasswordStrength
}                                    from '../../ap-dynforms/config/ap-dynforms-password-strength';
import {
  UserCreateFail
}                                    from '../../../../projects/invoker-transport/src/lib/actions/base-data';
import {
  NotifyStore
}                                    from '../../stores/dialog/notify.store';
import IUser = Data.Authentication.IUser;
import IInvitations = Data.Authentication.IInvitations;
import ApValidationLevel = Data.Api.Validation.ApValidationLevel;
import {ApDynformsConfigPlaceholder} from '../../ap-dynforms/config/ap-dynforms-config-placeholder';
import {ApSignalrService}            from '../../ap-core/services/ap-signalr.service';
import {ApBase64Util}                from '../../ap-utils/static/ap-base64-util';

@Component({
  selector: 'ap-invitations-new-user',
  templateUrl: 'ap-invitations-new-user.component.html',
  changeDetection: ChangeDetectionStrategy.Default
})
export class ApInvitationsNewUserComponent implements AfterContentInit, OnDestroy {
  @ViewChild(ApDynformsComponent, {static: true}) dynForm: ApDynformsComponent;
  @Input()
  public data: any;
  public formConfig: ApDynformsConfigFieldset[];
  public caption: string;
  public emailResult: boolean;
  public usernameResult: boolean;
  public submitClicked = false;
  public invitation = new BehaviorSubject<IInvitations>(null);
  public formValidators: ApDynformsValidator<ValidatorFn>[] = [
    new ApDynformsValidator({
      validator: this.pwdMatch,
      errorKey: 'Invitations__Msg_Vali_Mismatch_Password_Repeat_Password'
    }),
  ];
  private _subscriptions: Subscription[] = [];
  private _pwdInput = new BehaviorSubject<string>('');

  constructor(private userStore: UserStore,
              private invitationStore: InvitationStore,
              private translationStore: TranslationStore,
              private routerStore: RouterStore,
              private backend: ApSignalrService,
              private notifyStore: NotifyStore) {
  }

  ngAfterContentInit(): void {
    this.backend.registerObservable(UserCreateFail).subscribe((d) => {
      if (d.Data) {
        this.notifyStore.addMessage({
          ErrorKey: d.Data?.Message,
          Counter: 1,
          Level: ApValidationLevel.Error,
          Parameters: [],
          UserName: '',
          UserId: 0,
          DisplayTimeout: 3,
        });
      }
    });
    this.formBuilder();
    this.dynForm?.initialized.subscribe(() => {
      this.dynForm.form.get('Password')?.valueChanges.subscribe(v => this._pwdInput.next(v));
    });
    this.invitationStore.fetchInvitationById(this.routerStore.QueryParams.id)
      .then(i => this.invitation.next(i))
      .catch(err => console.warn(err.message));
    this._subscriptions.push(this.userStore.Listen(s => s.isUniqueEmail).subscribe(emailResult => {
      if (emailResult == null) {
        return;
      }
      this.emailResult = emailResult;
      if (this.emailResult) {
        this.dynForm?.initialized.subscribe(() => {
          this.dynForm.form.get('Email')?.setErrors({Error: this.translationStore.FindTranslationForSelectedLanguage('Msg_ToManyEmail')});
        });
      } else {
        this.dynForm?.initialized.subscribe(() => {
          this.dynForm.form.get('Email')?.setErrors(null);
        });
      }
    }));
    this._subscriptions.push(this.userStore.Listen(s => s.isNewUserCreated).subscribe(uinc => {
      if (uinc == null) {
        return;
      }
      this.invitationStore.confirmedWithUser(this.data.Id, this.data.ActivationCode, uinc.Id);
    }));
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(s => s.unsubscribe());
  }

  formBuilder(): void {
    this.formConfig = [
      new ApDynformsConfigFieldset({
        key: 'newUser_fieldset',
        legend: 'Admin_Pages__Registration',
        label: 'Admin_Pages_Login_Tip',
        columns: 1,
        config: [
          new ApDynformsConfigTextbox({
            key: 'Forename',
            label: 'Global__Forename',
            type: ApDynformsConfigTextboxType.Text,
            value: this.data.Forename,
            validators: [
              new ApDynformsValidator({
                validator: Validators.required,
                errorKey: 'Settings__Msg_Vali_Value_Required'
              }),
              new ApDynformsValidator({
                validator: Validators.nullValidator,
                errorKey: 'Settings__Msg_Vali_Value_Required'
              }),
              new ApDynformsValidator({
                validator: Validators.minLength(3),
                errorKey: 'Settings__Msg_Vali_Value_Required'
              }),
              new ApDynformsValidator({
                validator: Validators.maxLength(50),
                errorKey: 'Settings__Msg_Vali_Value_Required'
              })
            ]
          }),
          new ApDynformsConfigTextbox({
            key: 'Surname',
            label: 'Global__Surname',
            type: ApDynformsConfigTextboxType.Text,
            value: this.data.Surname,
            validators: [
              new ApDynformsValidator({
                validator: Validators.required,
                errorKey: 'Settings__Msg_Vali_Value_Required'
              }),
              new ApDynformsValidator({
                validator: Validators.nullValidator,
                errorKey: 'Settings__Msg_Vali_Value_Required'
              }),
              new ApDynformsValidator({
                validator: Validators.minLength(3),
                errorKey: 'Settings__Msg_Vali_Value_Required'
              }),
              new ApDynformsValidator({
                validator: Validators.maxLength(50),
                errorKey: 'Settings__Msg_Vali_Value_Required'
              })
            ]
          }),
          new ApDynformsConfigTextbox({
            key: 'Email',
            label: 'Global__Email',
            type: ApDynformsConfigTextboxType.Email,
            value$: this.invitation
              .pipe(map(x => x?.Email)),
            validators: [
              new ApDynformsValidator({
                validator: Validators.required,
                errorKey: 'Settings__Msg_Vali_Value_Required'
              }),
              new ApDynformsValidator({
                validator: Validators.email,
                errorKey: 'Admin_Pages_Login_Reset_Password_Email_Error'
              }),
              new ApDynformsValidator({
                validator: Validators.nullValidator,
                errorKey: 'Settings__Msg_Vali_Value_Required'
              }),
              new ApDynformsValidator({
                validator: Validators.minLength(1),
                errorKey: 'Settings__Msg_Vali_Value_Required'
              }),
              new ApDynformsValidator({
                validator: Validators.maxLength(80),
                errorKey: 'Settings__Msg_Vali_Value_Required'
              })
            ]
          }),
          new ApDynformsConfigTextbox({
            key: 'Password',
            label: 'PwRecover_NewPassword',
            type: ApDynformsConfigTextboxType.Password,
            autocomplete: 'new-password',
            value: this.data.Password,
            formErrors: ['Invitations__Msg_Vali_Mismatch_Password_Repeat_Password'],
            validators: [
              new ApDynformsValidator({
                validator: Validators.required,
                errorKey: 'Settings__Msg_Vali_Value_Required'
              }),
              new ApDynformsValidator({
                validator: Validators.nullValidator,
                errorKey: 'Settings__Msg_Vali_Value_Required'
              }),
            ]
          }),
          new ApDynformsConfigTextbox({
            key: 'PasswordRepeat',
            label: 'PwRecover_NewPasswordValidation',
            type: ApDynformsConfigTextboxType.Password,
            value: this.data.PasswordRepeat,
            formErrors: ['Invitations__Msg_Vali_Mismatch_Password_Repeat_Password'],
            validators: [
              new ApDynformsValidator({
                validator: Validators.required,
                errorKey: 'Settings__Msg_Vali_Value_Required'
              }),
              new ApDynformsValidator({
                validator: Validators.nullValidator,
                errorKey: 'Settings__Msg_Vali_Value_Required'
              }),
            ]
          }),
          new ApDynformsPasswordStrength({
            key: 'PasswordStrength',
            label$: new BehaviorSubject<string>(''),
            value$: this._pwdInput,
          }),
        ]
      })
    ];
    this.onChanges();
  }

  onSubmitClick(): void {
    merge(this.data, this.dynForm.form.value);
    if (this.data.Password !== this.data.PasswordRepeat) {
      return;
    }
    this.submitClicked = true;
    const user = {
      UserName: this.data.Username,
      PasswordHash: ApBase64Util.stringToBase64(this.data.Password),
      EMail: this.data.Email,
      RoleId: 0,
      Surname: this.data.Surname,
      Forename: this.data.Forename,
      Language: StringFactory.IsNullOrEmpty(this.routerStore.QueryParams.lang) ? 'en' : this.routerStore.QueryParams.lang.toLocaleUpperCase()
    } as IUser;
    this.userStore.createUser(user);
  }

  onChanges(): void {
    this.dynForm?.initialized.subscribe(() => {
      this.dynForm.form.get('Email')?.valueChanges
        .pipe(filter(x => !StringFactory.IsNullOrEmpty(x)))
        .subscribe(val => {
          this.userStore.checkUniqueEmail(val);
        });
    });
  }

  private pwdMatch(frm: FormGroup): { mismatch: boolean } | null {
    const same = frm.get('Password')?.value === frm.get('PasswordRepeat')?.value;
    ApDynformsComponent.setErrorOnControl(frm.get('Password'), 'Invitations__Msg_Vali_Mismatch_Password_Repeat_Password', !same);
    ApDynformsComponent.setErrorOnControl(frm.get('PasswordRepeat'), 'Invitations__Msg_Vali_Mismatch_Password_Repeat_Password', !same);
    return same ? null : {mismatch: true};
  }
}
